import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Utils } from 'versafleet-core';

const { RequestHelper: { request } } = Utils;

// eslint-disable-next-line import/prefer-default-export
export function useGetOrderDetails() {
  const { domain, detail } = useParams();

  const url = domain !== 'all'
    ? `/accounts/${domain}/tasks/${detail}/track`
    : `/tasks/${detail}/track`;

  const {
    isLoading: isLoadingOrderDetails,
    error: errorOrderDetails,
    data: orderDetails,
  } = useQuery({
    queryKey: ['orderDetails'],
    queryFn: async () => {
      const result = await request(url, {
        method: 'POST',
      });
      return result.task;
    },
  });

  return {
    isLoadingOrderDetails,
    errorOrderDetails,
    orderDetails,
  };
}
